import Terrible from '../../assets/crying.svg';
import Happy from '../../assets/happiness.svg';
import Indifferent from '../../assets/indifferent.svg';
import Sad from '../../assets/sad.svg';

export const terrible = Terrible;
export const happy = Happy;
export const indifferent = Indifferent;
export const sad = Sad;


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/emoji.js